import { addDays, startOfDay, startOfMonth, startOfYear } from 'date-fns';
import { createStaticRanges } from 'react-date-range';

export const orderRentalStatus = {
  CAN_RENTAL: 0,
  ON_RENT: 1,
  REVOKED: 2,
  RETURNED: 3,
  TROUBLE_ORDER: 4,
  CUSTOMER_PURCHASE: 5,
  SUSPEND_BILLING: 6,
  LOST: 7,
};

export const rentalStatusMap = {
  0: 'Can Rental',
  1: 'On Rent',
  2: 'Revoked',
  3: 'Returned',
  4: 'Trouble Order',
  5: 'Customer Purchase',
  6: 'Suspend Billing',
  7: 'Lost',
  8: 'On Maintenance',
};

export const orderPaymentStatus = {
  NOT_PAID: 0,
  PAID: 1,
  EVENT_FUNDED: 2,
  MAINTENANCE: 3,
  REFUNDED: 4,
};

export const paymentStatusMap = {
  0: 'Unpaid',
  1: 'Paid',
  2: 'Event Funded',
  3: 'Maintenance',
  4: 'Refunded',
};

export const paymentStatusColors = {
  0: 'red.500',
  1: 'green.500',
  2: 'green.500',
  3: 'green.500',
  4: 'red.500',
};

// Chart colors for merchant lines
export const merchantChartColors = [
  '#FF6B6B',
  '#4ECDC4',
  '#45B7D1',
  '#96CEB4',
  '#FFEAA7',
  '#DDA0DD',
  '#98D8C8',
  '#F7DC6F',
  '#BB8FCE',
  '#85C1E9',
  '#F8C471',
  '#82E0AA',
  '#F1948A',
  '#85C1E9',
  '#D7BDE2',
];

export const maintenanceFilterOptions = [
  { value: '', label: 'All' },
  { value: 'true', label: 'On' },
  { value: 'false', label: 'Off' },
];

export const temporarilyClosedFilterOptions = [
  { value: '', label: 'All' },
  { value: 'true', label: 'On' },
  { value: 'false', label: 'Off' },
];

export const comingSoonFilterOptions = [
  { value: '', label: 'All' },
  { value: 'true', label: 'On' },
  { value: 'false', label: 'Off' },
];

// Utility function to get payment status display information
export const getPaymentStatusInfo = (status) => {
  return {
    label: paymentStatusMap[status] || 'Unknown',
    color: paymentStatusColors[status] || 'gray.500',
  };
};

export const powerBankStatus = {
  1: 'Can Rent',
  2: 'On Rent',
  3: 'Customer Purchase',
  5: 'Lost',
  6: 'Block',
};

export const stationStatus = {
  1: 'Online',
  2: 'Offline',
};

export const stationStatusColors = {
  1: 'green.500',
  2: 'red.500',
};

export const networkStatus = {
  1: 'WIFI',
  2: 'SIM',
};

export const posStatus = {
  1: 'Online',
  2: 'Offline',
};

export const posStatusColors = {
  1: 'green.500',
  2: 'red.500',
};

export const merchantStatusMap = {
  open: 'Open',
  close: 'Close',
  not_set: 'Not Set',
};

export const merchantStatusColors = {
  open: 'green.500',
  close: 'red.500',
  not_set: 'gray.500',
};

// Fiskaly/AEAT transmission registration statuses (Spain merchant e-invoices).
export const transmissionStatusMap = {
  PENDING: 'Pending',
  REGISTERED: 'Registered',
  REGISTERED_WITH_ERRORS: 'Registered with errors',
  REJECTED: 'Rejected',
  REQUIRES_INSPECTION: 'Requires inspection (possible duplicate)',
};

export const transmissionStatusColors = {
  PENDING: 'gray.500',
  REGISTERED: 'green.500',
  REGISTERED_WITH_ERRORS: 'orange.500',
  REJECTED: 'red.500',
  REQUIRES_INSPECTION: 'yellow.600',
};

// Unknown/new statuses fall back to the raw value so nothing is hidden.
export const getTransmissionStatusInfo = (status) => {
  return {
    label: transmissionStatusMap[status] || status || 'N/A',
    color: transmissionStatusColors[status] || 'gray.500',
  };
};

// Credit (correction-invoice) statuses for merchant e-invoices.
export const creditStatusMap = {
  pending: 'Pending',
  crediting: 'Crediting…',
  credited: 'Credited',
  failed: 'Credit failed',
};

export const creditStatusColors = {
  pending: 'gray.500',
  crediting: 'blue.500',
  credited: 'green.500',
  failed: 'red.500',
};

export const getCreditStatusInfo = (status) => {
  return {
    label: creditStatusMap[status] || status || 'N/A',
    color: creditStatusColors[status] || 'gray.500',
  };
};

export const sideBarRoutes = {
  Admin: 1,
  Merchant: 3,
  Seller: 4,
  Dealer: 5,
  Organization: 6,
};
export const loginUserRole = {
  1: 'Super Admin',
  2: 'User',
  3: 'Merchant',
  4: 'Seller',
  5: 'Dealer',
  6: 'Organization',
};

export const RoleOption = [
  {
    id: 1,
    label: 'Admin',
  },
  {
    id: 3,
    label: 'Merchant',
  },
  {
    id: 4,
    label: 'Seller',
  },
  {
    id: 5,
    label: 'Dealer',
  },
  {
    id: 6,
    label: 'Organization',
  },
];

export const errorsColor = [
  '#FBB03B', // Vibrant Orange
  '#53EB95', // Bright Green
  '#203946', // Dark Teal
  '#16A34A', // Deep Green
  '#E63946', // Bold Red
  '#3A86FF', // Vivid Blue
  '#8338EC', // Rich Purple
  '#FF006E', // Hot Pink
  '#06D6A0', // Mint Green
  '#F77F00', // Warm Orange
  '#118AB2', // Deep Cyan
  '#8D99AE', // Muted Gray-Blue
  '#FFB400', // Golden Yellow
  '#2D6A4F', // Forest Green
  '#EF476F', // Coral Pink
  '#26547C', // Deep Navy
];

export const MerchantStationRevenueColor = [
  // '#06D6A0', // Mint Green
  // '#FFB400', // Golden Yellow
  // '#EF476F', // Coral Pink
  // '#118AB2', // Deep Cyan
  // '#F77F00', // Warm Orange
  // '#FF006E', // Hot Pink

  '#FBB03B', // Vibrant Orange
  '#53EB95', // Bright Green
  '#203946', // Dark Teal
  '#16A34A', // Deep Green
  '#E63946', // Bold Red
  '#3A86FF', // Vivid Blue
  '#8338EC', // Rich Purple
  '#FF006E', // Hot Pink
  '#06D6A0', // Mint Green
  '#F77F00', // Warm Orange
  '#118AB2', // Deep Cyan
  '#8D99AE', // Muted Gray-Blue
  '#FFB400', // Golden Yellow
  '#2D6A4F', // Forest Green
  '#EF476F', // Coral Pink
  '#26547C', // Deep Navy
];

export const customStaticRanges = createStaticRanges([
  {
    label: 'Today',
    range: () => ({
      startDate: startOfDay(new Date()),
      endDate: new Date(),
    }),
  },
  {
    label: 'Last 7 days',
    range: () => ({
      startDate: addDays(new Date(), -6),
      endDate: new Date(),
    }),
  },
  {
    label: 'Last 4 weeks',
    range: () => ({
      startDate: addDays(new Date(), -28),
      endDate: new Date(),
    }),
  },
  {
    label: 'Last 3 Months',
    range: () => {
      const today = new Date();
      const last3Months = new Date();
      last3Months.setMonth(today.getMonth() - 3);

      return {
        startDate: last3Months,
        endDate: today,
      };
    },
  },
  {
    label: 'Last 12 Months',
    range: () => {
      const today = new Date();
      const last12Months = new Date();
      last12Months.setMonth(today.getMonth() - 12);

      return {
        startDate: last12Months,
        endDate: today,
      };
    },
  },
  {
    label: 'Month to date',
    range: () => ({
      startDate: startOfMonth(new Date()),
      endDate: new Date(),
    }),
  },
  {
    label: 'Quarter to date',
    range: () => {
      const today = new Date();
      const threeMonthsAgo = new Date();
      threeMonthsAgo.setMonth(today.getMonth() - 3); // Subtract 3 months from today

      return {
        startDate: threeMonthsAgo,
        endDate: today,
      };
    },
  },
  {
    label: 'Year to date',
    range: () => ({
      startDate: startOfYear(new Date()),
      endDate: new Date(),
    }),
  },
  {
    label: 'All time',
    range: () => ({
      startDate: new Date(2000, 0, 1), // Set a very old date to include all time data
      endDate: new Date(),
    }),
    // range: () => {
    //   const currentYear = new Date().getFullYear();
    //   return {
    //     startDate: new Date(currentYear, 0, 1),
    //     endDate: new Date(),
    //   };
    // },
  },
]);

export const delearRoleregionsSelection = [
  {
    id: 1,
    label: 'Netherlands',
  },
  {
    id: 2,
    label: 'Spain',
  },
];

export const revenueOption = [
  {
    id: 1,
    label: 'Net Revenue',
  },
  {
    id: 2,
    label: 'Gross Revenue',
  },
  {
    id: 3,
    label: 'Post-Commission Share',
  },
];

export const DailyProfitabilityBarColors = {
  1: '#53EB95', // Bright Green
  2: '#FBB03B', // Vibrant Orange
  3: '#203946', // Green
  4: '#16A34A', // Black
};

export const YearOptionsForInvoice = Array.from({ length: 3 }, (_, index) => {
  const year = new Date().getFullYear() - index;
  return {
    id: index + 1,
    label: year.toString(),
  };
});

export const selectDaysOptions = [
  {
    id: 1,
    label: 'Quarters',
  },
  {
    id: 2,
    label: 'Months',
  },
];

export const QuarterOptionsForInvoice = [
  {
    id: 1,
    label: 'Quarter 1',
  },
  {
    id: 2,
    label: 'Quarter 2',
  },
  {
    id: 3,
    label: 'Quarter 3',
  },
  {
    id: 4,
    label: 'Quarter 4',
  },
];

export const monthsSelectionsOptions = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
].map((month, index) => ({
  id: index + 1,
  label: month,
}));

export const stationAttentionColorCode = [
  '#3A86FF', // Vivid Blue
  '#E63946', // Bold Red
  '#8338EC', // Rich Purple
  '#06D6A0', // Mint Green
  '#118AB2', // Deep Cyan
  '#2D6A4F', // Forest Green
  '#26547C', // Deep Navy
];

export const languageOptions = [
  {
    id: 'nl',
    label: 'Dutch',
  },
  {
    id: 'en',
    label: 'English',
  },
  {
    id: 'es',
    label: 'Spanish',
  },
];

export const regionLanguageConfig = [
  { regionId: 1, languageId: 'nl' },
  { regionId: 2, languageId: 'es' },
];

export const weekDays = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

// Get all available timezones dynamically using browser's Intl API
export const getTimezoneOptions = () => {
  // eslint-disable-next-line no-undef
  if (typeof Intl !== 'undefined' && Intl.supportedValuesOf) {
    // eslint-disable-next-line no-undef
    return Intl.supportedValuesOf('timeZone').map((timezone) => ({
      id: timezone,
      label: timezone,
    }));
  }
  return [];
};

export const timezoneOptions = getTimezoneOptions();

// Region to timezone mapping for auto-selection
export const regionTimezoneMapping = [
  { regionId: 1, timezoneId: 'Europe/Amsterdam' },
  { regionId: 2, timezoneId: 'Europe/Madrid' },
  { regionId: 3, timezoneId: 'Europe/Luxembourg' },
];

export const currencyOptions = [
  { code: 'EUR', symbol: '€', label: 'Euro (€) — EUR' },
  { code: 'GBP', symbol: '£', label: 'British Pound (£) — GBP' },
  { code: 'USD', symbol: '$', label: 'US Dollar ($) — USD' },
  { code: 'CHF', symbol: 'CHF', label: 'Swiss Franc (CHF) — CHF' },
  { code: 'SEK', symbol: 'kr', label: 'Swedish Krona (kr) — SEK' },
  { code: 'NOK', symbol: 'kr', label: 'Norwegian Krone (kr) — NOK' },
  { code: 'DKK', symbol: 'kr', label: 'Danish Krone (kr) — DKK' },
  { code: 'PLN', symbol: 'zł', label: 'Polish Złoty (zł) — PLN' },
  { code: 'CZK', symbol: 'Kč', label: 'Czech Koruna (Kč) — CZK' },
  { code: 'HUF', symbol: 'Ft', label: 'Hungarian Forint (Ft) — HUF' },
  { code: 'RON', symbol: 'lei', label: 'Romanian Leu (lei) — RON' },
  { code: 'BGN', symbol: 'лв', label: 'Bulgarian Lev (лв) — BGN' },
  { code: 'HRK', symbol: 'kn', label: 'Croatian Kuna (kn) — HRK' },
  { code: 'AUD', symbol: 'A$', label: 'Australian Dollar (A$) — AUD' },
  { code: 'CAD', symbol: 'C$', label: 'Canadian Dollar (C$) — CAD' },
  { code: 'NZD', symbol: 'NZ$', label: 'New Zealand Dollar (NZ$) — NZD' },
  { code: 'SGD', symbol: 'S$', label: 'Singapore Dollar (S$) — SGD' },
  { code: 'AED', symbol: 'د.إ', label: 'UAE Dirham (د.إ) — AED' },
  { code: 'SAR', symbol: '﷼', label: 'Saudi Riyal (﷼) — SAR' },
  { code: 'INR', symbol: '₹', label: 'Indian Rupee (₹) — INR' },
  { code: 'JPY', symbol: '¥', label: 'Japanese Yen (¥) — JPY' },
  { code: 'CNY', symbol: '¥', label: 'Chinese Yuan (¥) — CNY' },
  { code: 'KRW', symbol: '₩', label: 'South Korean Won (₩) — KRW' },
  { code: 'BRL', symbol: 'R$', label: 'Brazilian Real (R$) — BRL' },
  { code: 'MXN', symbol: 'MX$', label: 'Mexican Peso (MX$) — MXN' },
  { code: 'ZAR', symbol: 'R', label: 'South African Rand (R) — ZAR' },
];
